export const fr = {
  // Navigation
  nav: {
    home: "Accueil",
    primeEvolution: "Evolution",
    pulse: "Pulse",
    sparkle: "Sparkle",
    agents: "Agents",
    partners: "Partenaires",
    contact: "Contact",
    recruitAgent: "Recruter un Agent",
  },

  // Hero
  hero: {
    title: "Recrutez nos",
    titleHighlight: "Agents IA",
    titleEnd: "pour Renforcer vos Équipes",
    subtitle: "Des collaborateurs virtuels disponibles 24/7, formés à vos processus métier, prêts à transformer votre productivité.",
    cta: "Recruter un Agent IA",
    discover: "Découvrir Prime Evolution",
  },

  // Trust Banner
  trust: {
    available: "Disponible 24/7",
    secure: "100% Sécurisé",
    agents: "Agents Certifiés",
    support: "Support Dédié",
  },

  // Prime Evolution
  primeEvolution: {
    badge: "Notre Solution Phare",
    title: "Prime Evolution",
    subtitle: "Le programme d'accompagnement complet pour intégrer l'IA dans votre entreprise",
    description: "Prime Evolution est notre approche holistique qui combine audit, formation et déploiement d'agents IA sur-mesure pour transformer durablement votre organisation.",
    features: {
      audit: {
        title: "Audit Stratégique",
        description: "Analyse approfondie de vos processus pour identifier les opportunités d'automatisation à fort impact.",
      },
      training: {
        title: "Formation Équipes",
        description: "Programmes de formation adaptés pour que vos équipes maîtrisent et collaborent efficacement avec l'IA.",
      },
      deployment: {
        title: "Déploiement Sur-Mesure",
        description: "Agents IA personnalisés, intégrés à vos outils existants et formés sur vos données métier.",
      },
      support: {
        title: "Accompagnement Continu",
        description: "Support dédié et optimisation continue pour maximiser votre retour sur investissement.",
      },
    },
    cta: "Démarrer Prime Evolution",
    stats: {
      productivity: "Gain de productivité moyen",
      roi: "Retour sur investissement",
      satisfaction: "Taux de satisfaction client",
    },
  },

  // TagPDF
  sparkle: {
    badge: "Numérisation Intelligente",
    title: "Sparkle",
    subtitle: "TagPDF v7 propulsé par l'IA",
    description: "Transformez vos documents papier en données exploitables grâce à notre solution de numérisation intelligente. Reconnaissance automatique, extraction de données et classement intelligent.",
    features: {
      scan: {
        title: "Numérisation Avancée",
        description: "OCR de haute précision pour tous types de documents.",
      },
      ai: {
        title: "IA Intégrée",
        description: "Classification et extraction automatique des données clés.",
      },
      speed: {
        title: "Traitement Ultra-Rapide",
        description: "Des milliers de pages traitées en quelques minutes.",
      },
      accuracy: {
        title: "Précision Maximale",
        description: "Taux de reconnaissance supérieur à 99%.",
      },
    },
    cta: "Découvrir Sparkle",
    ctaFulltext: "Indexation Full-texte",
    ctaFulltextDesc: "Recherchez instantanément dans tous vos documents.",
    ctaScan: "Scan → Dossier Éclair",
    ctaScanDesc: "Numérisez et classez en un clin d'œil.",
  },

  // Pulse
  pulse: {
    badge: "Automatisation Intelligente",
    title: "VEECTORIA Pulse",
    subtitle: "L'automatisation qui pulse au rythme de votre entreprise",
    description: "Pulse est notre plateforme d'automatisation intelligente qui connecte, orchestre et optimise vos workflows en temps réel.",
    features: {
      connect: {
        title: "Connectez",
        description: "Intégration native avec plus de 200 outils et plateformes professionnelles.",
      },
      orchestrate: {
        title: "Orchestrez",
        description: "Workflows intelligents qui s'adaptent automatiquement à vos besoins.",
      },
      optimize: {
        title: "Optimisez",
        description: "Analyse en temps réel et recommandations pour améliorer vos processus.",
      },
    },
    cta: "Découvrir Pulse",
  },

  // Advantages
  advantages: {
    badge: "Pourquoi Nous Choisir",
    title: "Les Avantages VEECTORIA",
    subtitle: "Une approche unique qui combine expertise humaine et puissance de l'IA",
    items: {
      expertise: {
        title: "Expertise Reconnue",
        description: "Plus de 10 ans d'expérience en transformation digitale et IA.",
      },
      custom: {
        title: "Solutions Sur-Mesure",
        description: "Chaque agent est formé spécifiquement sur vos processus et données.",
      },
      security: {
        title: "Sécurité Maximale",
        description: "Données hébergées en Europe, conformité RGPD garantie.",
      },
      roi: {
        title: "ROI Garanti",
        description: "Engagement sur les résultats avec des indicateurs mesurables.",
      },
      support: {
        title: "Support 24/7",
        description: "Équipe dédiée disponible à tout moment pour vous accompagner.",
      },
      evolution: {
        title: "Évolution Continue",
        description: "Vos agents s'améliorent constamment grâce au machine learning.",
      },
    },
  },

  // Testimonials
  testimonials: {
    badge: "Témoignages",
    title: "Ils Nous Font Confiance",
    subtitle: "Découvrez comment nos clients transforment leur entreprise avec VEECTORIA",
    items: [
      {
        quote: "Grâce à VEECTORIA, nous avons réduit de 70% le temps consacré aux tâches administratives.",
        metric: "-70%",
        metricLabel: "temps administratif",
        name: "Isabelle G.",
        role: "Responsable Administrative",
      },
      {
        quote: "L'agent IA commercial a transformé notre prospection. +40% de rendez-vous qualifiés.",
        metric: "+40%",
        metricLabel: "rendez-vous qualifiés",
        name: "Marc D.",
        role: "Directeur Commercial",
      },
      {
        quote: "La solution documentaire nous fait gagner un temps précieux sur la gestion des dossiers.",
        metric: "5x",
        metricLabel: "plus rapide",
        name: "Sophie M.",
        role: "Gérante",
      },
    ],
  },

  // FAQ
  faq: {
    badge: "Questions Fréquentes",
    title: "Tout Savoir sur VEECTORIA",
    subtitle: "Les réponses à vos questions les plus courantes",
    items: {
      q1: {
        question: "Qu'est-ce qu'un Agent IA VEECTORIA ?",
        answer: "Un Agent IA VEECTORIA est un collaborateur virtuel intelligent, formé sur vos processus métier spécifiques. Il peut gérer des tâches variées : support client, analyse de données, rédaction, gestion administrative, et bien plus encore.",
      },
      q2: {
        question: "Combien de temps faut-il pour déployer un agent ?",
        answer: "Le déploiement standard prend entre 2 et 4 semaines, incluant l'audit initial, la configuration, la formation sur vos données et les tests. Pour des besoins plus complexes, comptez 6 à 8 semaines.",
      },
      q3: {
        question: "Mes données sont-elles sécurisées ?",
        answer: "Absolument. Toutes les données sont hébergées en Europe sur des serveurs certifiés. Nous sommes 100% conformes au RGPD et appliquons les plus hauts standards de sécurité (chiffrement, accès contrôlés, audits réguliers).",
      },
      q4: {
        question: "Quel est le retour sur investissement attendu ?",
        answer: "Nos clients constatent en moyenne un gain de productivité de 40% et un ROI positif dès les 3 premiers mois. Nous nous engageons sur des résultats mesurables.",
      },
      q5: {
        question: "Comment se passe l'intégration avec nos outils existants ?",
        answer: "VEECTORIA s'intègre nativement avec plus de 200 outils professionnels (CRM, ERP, outils de communication, etc.). Notre équipe technique assure une intégration fluide sans perturber vos opérations.",
      },
    },
  },

  // Contact
  contact: {
    badge: "Contactez-Nous",
    title: "Prêt à Transformer Votre Entreprise ?",
    subtitle: "Discutons de vos besoins et découvrez comment VEECTORIA peut vous accompagner",
    form: {
      name: "Nom complet",
      email: "Email professionnel",
      company: "Entreprise",
      phone: "Téléphone",
      message: "Votre message",
      submit: "Envoyer le message",
      sending: "Envoi en cours...",
      success: "Message envoyé avec succès !",
      error: "Erreur lors de l'envoi. Veuillez réessayer.",
    },
    info: {
      title: "Informations de Contact",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
    },
  },

  // CTA
  cta: {
    title: "Prêt à Passer à l'Action ?",
    subtitle: "Rejoignez les entreprises qui ont déjà transformé leur productivité avec VEECTORIA",
    button: "Recruter un Agent IA",
  },

  // Footer
  footer: {
    description: "Solutions d'intelligence artificielle pour transformer votre entreprise.",
    navigation: "Navigation",
    legal: "Mentions Légales",
    privacy: "Politique de Confidentialité",
    terms: "Conditions Générales",
    cookies: "Gestion des Cookies",
    rights: "Tous droits réservés.",
  },

  // Agents Carousel
  agents: {
    badge: "Notre Équipe",
    title: "Nos Agents IA",
    subtitle: "Découvrez nos collaborateurs virtuels prêts à rejoindre votre équipe",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "L'Excellence de l'IA au Service de Votre Entreprise",
    title: "Nos Agents IA Transforment Votre Quotidien",
    description: "Imaginez une équipe de collaborateurs virtuels qui ne dort jamais, qui apprend continuellement et qui s'adapte parfaitement à vos processus métier. Nos Agents IA augmentent vos capacités, libèrent vos talents des tâches répétitives et propulsent votre productivité vers de nouveaux sommets.",
    imageAlt: "Équipe d'Agents IA VEECTORIA",
    cta: "Découvrir Nos Agents",
    benefits: {
      availability: "Disponibles 24h/24",
      productivity: "Productivité x10",
      performance: "Performance Optimale",
      collaboration: "Collaboration Fluide",
    },
  },

  // Cookie consent
  cookies: {
    title: "Gestion des cookies",
    message: "Nous utilisons des cookies pour améliorer votre expérience sur notre site, analyser le trafic et personnaliser le contenu. Vous pouvez personnaliser vos préférences ou accepter tous les cookies.",
    accept: "Tout accepter",
    decline: "Refuser",
    settings: "Personnaliser",
    settingsTitle: "Paramètres des cookies",
    settingsDescription: "Gérez vos préférences de cookies. Les cookies essentiels sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés.",
    saveChoices: "Enregistrer mes choix",
    rejectAll: "Refuser tout",
    alwaysActive: "Toujours actif",
    categories: {
      essential: { name: "Cookies essentiels", description: "Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés. Ils permettent la navigation et l'accès aux fonctionnalités de base." },
      analytics: { name: "Cookies analytiques", description: "Ces cookies nous permettent de mesurer l'audience du site et d'analyser les comportements de navigation pour améliorer nos services." },
      marketing: { name: "Cookies marketing", description: "Ces cookies sont utilisés pour vous proposer des publicités personnalisées et mesurer l'efficacité de nos campagnes marketing." },
      preferences: { name: "Cookies de préférences", description: "Ces cookies mémorisent vos préférences (langue, thème, région) pour personnaliser votre expérience sur le site." },
    },
  },

  // Partners Section
  partners: {
    badge: "Programme Partenaires",
    title: "Développons Ensemble",
    description: "Vous êtes revendeur, distributeur, éditeur ou grossiste ? VEECTORIA devient votre partenaire technologique privilégié pour conquérir de nouveaux marchés avec des solutions d'intelligence artificielle de pointe.",
    valueProposition: "Nous concevons et développons des solutions professionnelles complètes et personnalisées pour vos clients, tout en vous accompagnant dans la mise en place d'une stratégie de commercialisation de masse. Marges attractives, support technique dédié, et accompagnement marketing : tous les ingrédients pour votre succès.",
    types: {
      resellers: {
        title: "Revendeurs",
        description: "Intégrez nos solutions IA à votre catalogue et proposez des offres différenciantes à vos clients.",
      },
      distributors: {
        title: "Distributeurs",
        description: "Déployez nos technologies à grande échelle sur votre territoire avec un accompagnement privilégié.",
      },
      editors: {
        title: "Éditeurs",
        description: "Enrichissez vos logiciels avec notre IA et créez une valeur ajoutée incomparable.",
      },
      wholesalers: {
        title: "Grossistes",
        description: "Accédez à des tarifs préférentiels pour une distribution massive auprès de vos réseaux.",
      },
    },
    benefits: {
      title: "Vos Avantages Partenaires",
      whiteLabel: "Solutions marque blanche",
      support: "Support technique dédié",
      scalability: "Scalabilité illimitée",
    },
    cta: "Devenez Partenaire",
    ctaSubtext: "Contactez-nous pour découvrir notre programme partenaires exclusif",
  },

  // Legal modals
  legal: {
    lastUpdate: "Dernière mise à jour : Janvier 2026",
    mentions: {
      title: "Mentions Légales",
      sections: {
        editor: {
          title: "1. Éditeur du site",
          intro: "Le présent site est édité par :",
          companyName: "Raison sociale",
          legalForm: "Forme juridique",
          capital: "Capital social",
          address: "Siège social",
          siren: "SIREN",
          siret: "SIRET",
          rcs: "RCS",
          tva: "N° TVA Intracommunautaire",
          naf: "Code NAF",
        },
        publication: {
          title: "2. Direction de la publication",
          intro: "La direction de la publication est assurée par :",
          since: "depuis le",
        },
        contact: {
          title: "3. Contact",
          phone: "Téléphone",
          email: "Email",
        },
        hosting: {
          title: "4. Hébergement",
          intro: "Le site est hébergé par :",
          name: "Nom",
          address: "Adresse",
        },
        intellectual: {
          title: "5. Propriété intellectuelle",
          content1: "L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.",
          content2: "La reproduction de tout ou partie de ce site sur quelque support que ce soit est formellement interdite sauf autorisation expresse de",
        },
        liability: {
          title: "6. Limitation de responsabilité",
          content: "Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement mis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes. {company} ne pourra être tenue responsable des dommages directs ou indirects résultant de l'utilisation de ce site.",
        },
        law: {
          title: "7. Droit applicable",
          content: "Le présent site et les mentions légales sont soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.",
        },
      },
    },
    privacy: {
      title: "Politique de Confidentialité",
      sections: {
        intro: {
          title: "1. Introduction",
          content: "{company} s'engage à protéger la vie privée des utilisateurs de son site. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD).",
        },
        controller: {
          title: "2. Responsable du traitement",
          company: "Société",
          address: "Adresse",
          email: "Email",
        },
        data: {
          title: "3. Données collectées",
          intro: "Nous collectons les données suivantes :",
          items: [
            "Données d'identification : nom, prénom, email, téléphone",
            "Données professionnelles : entreprise, fonction",
            "Données de navigation : adresse IP, cookies, pages visitées",
            "Données de communication : messages via formulaires de contact",
          ],
        },
        purposes: {
          title: "4. Finalités du traitement",
          intro: "Vos données sont collectées pour :",
          items: [
            "Répondre à vos demandes de contact et de démonstration",
            "Vous fournir nos services et solutions IA",
            "Améliorer notre site et nos services",
            "Vous envoyer des communications commerciales (avec votre consentement)",
            "Respecter nos obligations légales",
          ],
        },
        basis: {
          title: "5. Base légale",
          intro: "Le traitement de vos données repose sur :",
          items: [
            "Votre consentement explicite",
            "L'exécution d'un contrat",
            "Notre intérêt légitime",
            "Le respect d'obligations légales",
          ],
        },
        retention: {
          title: "6. Durée de conservation",
          content: "Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, et au maximum 3 ans après votre dernier contact avec nous.",
        },
        rights: {
          title: "7. Vos droits",
          intro: "Conformément au RGPD, vous disposez des droits suivants :",
          access: "Droit d'accès",
          accessDesc: "obtenir une copie de vos données",
          rectification: "Droit de rectification",
          rectificationDesc: "corriger vos données inexactes",
          erasure: "Droit à l'effacement",
          erasureDesc: "demander la suppression de vos données",
          restriction: "Droit à la limitation",
          restrictionDesc: "limiter le traitement de vos données",
          portability: "Droit à la portabilité",
          portabilityDesc: "recevoir vos données dans un format structuré",
          objection: "Droit d'opposition",
          objectionDesc: "vous opposer au traitement de vos données",
          contact: "Pour exercer ces droits, contactez-nous à :",
        },
        security: {
          title: "8. Sécurité",
          content: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.",
        },
        complaint: {
          title: "9. Réclamation",
          content: "Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : www.cnil.fr",
        },
      },
    },
    cgv: {
      title: "Conditions Générales de Vente",
      sections: {
        object: {
          title: "1. Objet",
          content: "Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre {company} et ses clients pour la fourniture de services d'intelligence artificielle, de développement logiciel et de solutions métiers.",
        },
        provider: {
          title: "2. Prestataire",
          company: "Société",
          siret: "SIRET",
          address: "Siège",
        },
        services: {
          title: "3. Services proposés",
          intro: "{company} propose les services suivants :",
          items: [
            "Agents IA spécialisés (transcription, gestion, support, etc.)",
            "Développement d'applications métiers sur-mesure (Prime Evolution)",
            "Solutions d'IA documentaire",
            "VEECTORIA Pulse - Plateforme de transcription et comptes rendus",
            "Conseil et intégration de solutions IA",
          ],
        },
        quotes: {
          title: "4. Devis et commandes",
          content: "Toute prestation fait l'objet d'un devis détaillé. La commande est considérée comme définitive après signature du devis et réception de l'acompte prévu.",
        },
        pricing: {
          title: "5. Tarifs et paiement",
          content1: "Les tarifs sont indiqués en euros hors taxes. La TVA applicable est de 20%. Sauf mention contraire, les factures sont payables à 30 jours fin de mois.",
          content2: "En cas de retard de paiement, des pénalités de retard seront appliquées au taux de 3 fois le taux d'intérêt légal, ainsi qu'une indemnité forfaitaire de 40€ pour frais de recouvrement.",
        },
        delivery: {
          title: "6. Livraison et délais",
          content: "Les délais de livraison sont donnés à titre indicatif. {company} s'engage à respecter les délais convenus dans le devis, sauf circonstances exceptionnelles.",
        },
        intellectual: {
          title: "7. Propriété intellectuelle",
          content: "Sauf stipulation contraire, les développements réalisés par {company} restent sa propriété jusqu'au paiement intégral de la prestation. Après paiement, les droits d'utilisation sont transférés au client selon les modalités définies au contrat.",
        },
        confidentiality: {
          title: "8. Confidentialité",
          content: "Chaque partie s'engage à maintenir confidentielles les informations échangées dans le cadre de la relation commerciale pendant une durée de 3 ans après la fin du contrat.",
        },
        liability: {
          title: "9. Limitation de responsabilité",
          content: "La responsabilité de {company} est limitée au montant des sommes effectivement perçues au titre du contrat concerné. {company} ne peut être tenue responsable des dommages indirects.",
        },
        law: {
          title: "10. Droit applicable",
          content: "Les présentes CGV sont soumises au droit français. Tout litige sera porté devant les tribunaux compétents de Paris.",
        },
      },
    },
    cookiesPolicy: {
      title: "Politique des Cookies",
      sections: {
        what: {
          title: "1. Qu'est-ce qu'un cookie ?",
          content: "Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette, smartphone) lors de la visite d'un site web. Il permet au site de mémoriser des informations sur votre visite.",
        },
        types: {
          title: "2. Cookies utilisés",
          intro: "Notre site utilise les types de cookies suivants :",
          essential: "Cookies essentiels",
          essentialDesc: "Nécessaires au fonctionnement du site. Ils ne peuvent pas être désactivés.",
          analytics: "Cookies analytiques",
          analyticsDesc: "Nous permettent de comprendre comment vous utilisez notre site pour l'améliorer.",
          preferences: "Cookies de préférences",
          preferencesDesc: "Mémorisent vos choix (langue, thème) pour personnaliser votre expérience.",
        },
        retention: {
          title: "3. Durée de conservation",
          content: "Les cookies sont conservés pour une durée maximale de 13 mois conformément aux recommandations de la CNIL.",
        },
        management: {
          title: "4. Gestion des cookies",
          intro: "Vous pouvez à tout moment modifier vos préférences en matière de cookies via les paramètres de votre navigateur :",
          items: [
            "Chrome : Paramètres → Confidentialité et sécurité → Cookies",
            "Firefox : Options → Vie privée et sécurité → Cookies",
            "Safari : Préférences → Confidentialité → Cookies",
            "Edge : Paramètres → Cookies et autorisations de site",
          ],
        },
        contact: {
          title: "5. Contact",
          content: "Pour toute question concernant notre utilisation des cookies, contactez-nous à :",
        },
      },
    },
  },
};

export type Translations = typeof fr;
